(function() {
  document.addEventListener('alpine:init', function() {
    Alpine.store('cityPopup', {
      selectedCity: null,
      productId: null,
      setCity: function(city, productId) {
        this.selectedCity = city;
        this.productId = productId;
      },
      isBogota: function() {
        if (!this.selectedCity) return false;
        var normalized = this.selectedCity.toString().toLowerCase();
        try {
          normalized = normalized.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        } catch (e) {}
        return normalized === 'bogota';
      }
    });
    var cityPopups = document.querySelectorAll('[id^="CityPopup-"]');
    cityPopups.forEach(function(popup) {
      var productId = parseInt(popup.dataset.productId || popup.getAttribute('data-product-id') || '0', 10);
      if (!productId) return;
      var savedCity = sessionStorage.getItem('city-selected-product-' + productId);
      if (savedCity && Alpine.store('cityPopup')) {
        Alpine.store('cityPopup').setCity(savedCity, productId);
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCityPopup);
  } else {
    initCityPopup();
  }

  function initCityPopup() {
    var cityPopups = document.querySelectorAll('[id^="CityPopup-"]');
    if (!cityPopups.length) return;

    cityPopups.forEach(function(popup) {
      var sectionId = popup.id.replace('CityPopup-', '');
      var productId = parseInt(popup.dataset.productId || popup.getAttribute('data-product-id') || '0', 10);
      if (!sectionId || !productId) return;

      if (window.Alpine && Alpine.store('cityPopup')) {
        var savedCity = sessionStorage.getItem('city-selected-product-' + productId);
        if (savedCity) Alpine.store('cityPopup').setCity(savedCity, productId);
      }

      setupCityPopup(sectionId, productId);
    });
  }

  function setupCityPopup(sectionId, productId) {
    function modifyQuantitySelector(city) {
      var isBogota = false;
      if (city) {
        var normalized = city.toString().toLowerCase();
        try {
          normalized = normalized.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        } catch (e) {}
        isBogota = normalized === 'bogota';
      }
      var quantityInputs = document.querySelectorAll('#Quantity-' + sectionId + ', #Quantity-atc-' + sectionId);

      quantityInputs.forEach(function(input) {
        if (input._cityQuantityHandler) {
          input.removeEventListener('input', input._cityQuantityHandler);
          input.removeEventListener('change', input._cityQuantityHandler);
          delete input._cityQuantityHandler;
        }

        var container = input.closest('[x-data]') || input.parentElement;
        var plusButton = container && container.querySelector('button[name="plus"]');
        var minusButton = container && container.querySelector('button[name="minus"]');

        if (!isBogota) {
          input.setAttribute('min', '2');
          input.setAttribute('step', '2');
          var val = parseInt(input.value, 10) || 2;
          if (val < 2) val = 2;
          else if (val % 2 !== 0) {
            val = Math.round(val / 2) * 2;
            if (val < 2) val = 2;
          }
          input.value = val;

          var quantityHandler = function() {
            var validatedValue = parseInt(this.value, 10) || 2;
            if (validatedValue < 2) validatedValue = 2;
            else if (validatedValue % 2 !== 0) {
              validatedValue = Math.round(validatedValue / 2) * 2;
              if (validatedValue < 2) validatedValue = 2;
            }
            this.value = validatedValue;
            var alpineData = this.closest('[x-data]');
            if (alpineData && window.Alpine && alpineData.__x) {
              var alpineInstance = alpineData.__x.$data;
              if (alpineInstance) alpineInstance.qty = validatedValue;
            }
          };
          input._cityQuantityHandler = quantityHandler;
          input.addEventListener('input', quantityHandler);
          input.addEventListener('change', quantityHandler);

          if (plusButton && !plusButton._cityPlusHandler) {
            var plusHandler = function(e) {
              e.preventDefault();
              e.stopPropagation();
              var quantityInput = document.querySelector('#Quantity-' + sectionId) || document.querySelector('#Quantity-atc-' + sectionId);
              if (quantityInput) {
                var currentVal = parseInt(quantityInput.value, 10) || 2;
                currentVal += 2;
                quantityInput.value = currentVal;
                quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
                quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
                var alpineData = quantityInput.closest('[x-data]');
                if (alpineData && window.Alpine && alpineData.__x) {
                  var alpineInstance = alpineData.__x.$data;
                  if (alpineInstance) alpineInstance.qty = currentVal;
                }
              }
            };
            plusButton._cityPlusHandler = plusHandler;
            plusButton.addEventListener('click', plusHandler, true);
          }

          if (minusButton && !minusButton._cityMinusHandler) {
            var minusHandler = function(e) {
              e.preventDefault();
              e.stopPropagation();
              var quantityInput = document.querySelector('#Quantity-' + sectionId) || document.querySelector('#Quantity-atc-' + sectionId);
              if (quantityInput) {
                var currentVal = parseInt(quantityInput.value, 10) || 2;
                if (currentVal <= 2) currentVal = 2;
                else {
                  currentVal -= 2;
                  if (currentVal < 2) currentVal = 2;
                }
                quantityInput.value = currentVal;
                quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
                quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
                var alpineData = quantityInput.closest('[x-data]');
                if (alpineData && window.Alpine && alpineData.__x) {
                  var alpineInstance = alpineData.__x.$data;
                  if (alpineInstance) alpineInstance.qty = currentVal;
                }
              }
            };
            minusButton._cityMinusHandler = minusHandler;
            minusButton.addEventListener('click', minusHandler, true);
          }
        } else {
          input.removeAttribute('min');
          input.removeAttribute('step');
          if (plusButton && plusButton._cityPlusHandler) {
            plusButton.removeEventListener('click', plusButton._cityPlusHandler, true);
            delete plusButton._cityPlusHandler;
          }
          if (minusButton && minusButton._cityMinusHandler) {
            minusButton.removeEventListener('click', minusButton._cityMinusHandler, true);
            delete minusButton._cityMinusHandler;
          }
          setTimeout(function() {
            var alpineData = input.closest('[x-data]');
            if (alpineData && window.Alpine && alpineData.__x) {
              var alpineInstance = alpineData.__x.$data;
              if (alpineInstance) {
                alpineInstance.min = 1;
                var qty = parseInt(alpineInstance.qty, 10) || 1;
                if (qty < 1) qty = 1;
                alpineInstance.qty = qty;
                input.value = qty;
              }
            }
          }, 300);
        }
      });
    }

    window.addEventListener('city-selected', function(event) {
      if (event.detail && event.detail.productId === productId) {
        if (window.Alpine && Alpine.store('cityPopup')) {
          Alpine.store('cityPopup').setCity(event.detail.city, productId);
        }
        modifyQuantitySelector(event.detail.city);
      }
    });

    var savedCity = sessionStorage.getItem('city-selected-product-' + productId);
    if (savedCity) {
      modifyQuantitySelector(savedCity);
      setTimeout(function() { modifyQuantitySelector(savedCity); }, 200);
    }
  }
})();
